/**
 * Normalize a Czech municipality name for matching:
 *  - lowercase
 *  - strip diacritics (NFD, then drop combining marks)
 *  - collapse internal whitespace and dashes
 *  - trim
 *
 * This way "Plzeň", "plzen" and "PLZEN" all match the same key, and
 * compound names like "Brandýs nad Labem-Stará Boleslav" tolerate
 * minor whitespace/punctuation variations.
 */
export function normalize(input: string): string {
  return input
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // combining diacritics
    .toLowerCase()
    .replace(/[\s\-_]+/g, " ")
    .trim();
}
